export enum TAPIResponseStatus {
  failure = 'failure',
  success = 'success',
}

export type QueryReturnValue<T = unknown, E = unknown, M = unknown> =
  | {
      error: E;
      meta?: M;
      data?: undefined;
    }
  | {
      error?: undefined;
      data: T;
      meta?: M;
    };

export type APIResponse<T> = {
  status: TAPIResponseStatus;
  error?: {
    err: null | string;
    message: string;
  };
  data?: T;
};

export type APIResponseOneBox3<T> = {
  from: string;
  err: number;
  data?: T;
  msg?: string;
};
